module.exports = __webpack_public_path__ + "static/img/you-en.ff16fe5b.png";